import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]     = useState(false);
  const [error, setError]   = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email.trim()) { setError('Please enter your email address.'); return; }
    setError(''); setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setDone(true);
    } catch(_) {
      // Always show success — never reveal if email exists
      setDone(true);
    } finally { setLoading(false); }
  }

  return (
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--bg)',fontFamily:'inherit'}}>
      <div style={{width:'100%',maxWidth:'400px',padding:'0 20px'}}>
        <div style={{textAlign:'center',marginBottom:'32px'}}>
          <div style={{width:56,height:56,borderRadius:'14px',background:'linear-gradient(135deg,#5B5BD6,#7C3AED)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'24px',fontWeight:'900',color:'#fff',margin:'0 auto 16px'}}>T</div>
          <h2 style={{fontSize:'24px',fontWeight:'800',color:'var(--text)',margin:'0 0 6px'}}>Reset your password</h2>
          <p style={{color:'var(--muted)',fontSize:'14px',margin:0}}>Enter your email and we will send you a reset link</p>
        </div>

        {done ? (
          <div style={{background:'rgba(22,163,74,0.08)',border:'1px solid rgba(22,163,74,0.3)',borderRadius:'12px',padding:'20px',textAlign:'center'}}>
            <div style={{fontSize:'32px',marginBottom:'12px'}}>📧</div>
            <div style={{fontWeight:'700',color:'var(--text)',marginBottom:'8px'}}>Check your email</div>
            <div style={{fontSize:'13px',color:'var(--muted)',lineHeight:1.6}}>
              If an account exists for that email address, you will receive a password reset link within a few minutes.
            </div>
            <Link to="/login" style={{display:'inline-block',marginTop:'20px',color:'#5B5BD6',fontWeight:'600',fontSize:'13px',textDecoration:'none'}}>← Back to login</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{background:'rgba(220,38,38,0.08)',border:'1px solid rgba(220,38,38,0.25)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',color:'#DC2626',display:'flex',gap:'8px',alignItems:'center'}}>
                <span>⚠️</span><span>{error}</span>
              </div>
            )}
            <div style={{marginBottom:'20px'}}>
              <label style={{display:'block',fontSize:'13px',fontWeight:'600',color:'var(--text)',marginBottom:'6px'}}>Email Address</label>
              <input className="input" type="email" value={email} onChange={e=>{setEmail(e.target.value);setError('');}}
                placeholder="Enter your email" autoFocus required
                style={{width:'100%',padding:'11px 14px',fontSize:'14px',borderRadius:'10px',boxSizing:'border-box'}}/>
            </div>
            <button type="submit" disabled={loading}
              style={{width:'100%',padding:'12px',fontSize:'14px',fontWeight:'700',borderRadius:'10px',border:'none',cursor:loading?'not-allowed':'pointer',background:loading?'#9CA3AF':'linear-gradient(135deg,#5B5BD6,#7C3AED)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',gap:'8px'}}>
              {loading?(<><div style={{width:14,height:14,border:'2px solid rgba(255,255,255,0.4)',borderTopColor:'#fff',borderRadius:'50%',animation:'spin .7s linear infinite'}}/>Sending…</>):'Send Reset Link'}
            </button>
            <div style={{textAlign:'center',marginTop:'20px'}}>
              <Link to="/login" style={{color:'var(--muted)',fontSize:'13px',textDecoration:'none'}}>← Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
